<template>
    <select
        class="mt-1 block w-full appearance-none rounded border border-gray-200 px-3 py-2.5 placeholder-gray-400 shadow-sm focus:border-gray-600 focus:outline-none focus:ring-0 text-sm bg-neutral-50 focus:bg-white"
        :value="modelValue" @change="onChange($event)"
    >
        <slot/>
    </select>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, Number], // or the appropriate type(s) for your select
            required: true
        }
    },

    methods: {
        onChange(event) {
            // emit the update:modelValue event with the new value when the select value changes
            this.$emit('update:modelValue', event.target.value);
        }
    }
};
</script>
